module.exports = __webpack_public_path__ + "static/media/group-view.6706ffc4.png";